import type { CSSProperties } from "react";
import { flexRender, type Cell } from "@tanstack/react-table";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function TableDataCell<T>({ cell }: { cell: Cell<T, unknown> }) {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: cell.column.id,
    disabled: cell.column.getCanPin(),
  });

  const borderColor =
    (cell.column.columnDef.meta as any)?.borderColor || "rgb(204,0,0)";

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: cell.column.getIsPinned() ? "sticky" : "relative",
    left: cell.column.getIsPinned() ? cell.column.getStart("left") : undefined,
    zIndex: cell.column.getIsPinned() ? 50 : 0,
    transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
    transition: "width transform 0.2s ease-in-out",
    // borderLeft: cell.column.getIsPinned() ? "6px solid red" : "",
    borderLeft: cell.column.id === "select" ? `6px solid ${borderColor}` : "",
  };
  const isCheckbox = cell.column.id === "select";
  const align = cell.column.columnDef.meta?.align ?? "center";
  const vAlign = cell.column.columnDef.meta?.vAlign ?? "middle";
  const padding = cell.column.columnDef.meta?.padding ?? "md";

  const alignmentClass =
    align === "left"
      ? "justify-start text-left"
      : align === "right"
        ? "justify-end text-right"
        : "justify-center text-center";

  const vAlignmentClass =
    vAlign === "top"
      ? "items-start"
      : vAlign === "bottom"
        ? "items-end"
        : "items-center";

  const paddingClass = padding === "sm" ? "p-2" : padding === "lg" ? "p-6" : "";

  return (
    <div
      key={cell.id}
      ref={setNodeRef}
      role="cell"
      className={`flex ${
        isCheckbox ? "justify-center items-center" : vAlignmentClass
      } ${alignmentClass} ${paddingClass} box-border w-full border-r border-b bg-white
         border-b-gray-200 text-center transition ${
           cell.column.getIsResizing()
             ? "border-r-blue-600"
             : "border-r-gray-200"
         }`}
      style={style}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </div>
  );
}
